import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchContractOrders, loadOrder } from '../Services/loadOrder';
import { Search } from 'lucide-react';
import '../assets/css/home.css';
import MenuBar from './common/MenuBar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import toast,{Toaster} from 'react-hot-toast';
import { FormControl, MenuItem, InputLabel, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
// import "../assets/documents/TN Addendum To WINRx PBM Manual V5 (1).docx"

const ContractDashboard = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [contracts, setContracts] = useState([]);
  const [medStartDates, setMedStartDates] = useState([]);
  const [filteredContracts, setFilteredContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchPlaceholder, setSearchPlaceholder] = useState('Search Dates...');
  const [selectedCompliance, setSelectedCompliance] = useState('off');
  const [showSidebar, setShowSidebar] = useState(false);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const userId = user?.UserID || user?.userId;
  const pharmacyId = user?.pharmacyId || user?.PharmacyID;
  const [selectedName, setSelectedName] = useState('MedStartDate'); // Default to Meds Needed Date

useEffect(() => {
  const handlePopState = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.userId && user?.pharmacyId) {
      // Cancel the back by immediately returning to the forward entry
      window.history.go(1); // same as history.forward()

      // Keep the current URL as the active entry *without* adding to history
      // (also handy to stash a flag in state if you want)
      window.history.replaceState(
        { blockBack: true, ts: Date.now() },
        '',
        window.location.href
      );
    }
  };

  // 1) Tag the current entry (no new entry created)
  window.history.replaceState(
    { blockBack: true, ts: Date.now() },
    '',
    window.location.href
  );

  // 2) Seed ONE forward entry so the first Back can be neutralized with go(1)
  window.history.pushState({ anchor: true }, '', window.location.href);

  window.addEventListener('popstate', handlePopState);
  return () => window.removeEventListener('popstate', handlePopState);
}, []);


  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        console.log('User data:', user);
        const pharmacyId = user?.pharmacyId || user?.PharmacyID;
        console.log('Pharmacy ID:', pharmacyId);
        const response = await fetchContractOrders(pharmacyId); 
        const data = response.data;
        const processAndNeeds = response.ProcessAndNeeds;

        // Get array of MedStartDate strings (not objects)
        const medStartDates = processAndNeeds
          .map(item => item?.MedStartDate)
          .filter(Boolean); // Remove undefined/null

          // Count occurrences of each formatted date
const dateCountMap = new Map();
medStartDates.forEach(date => {
  const formatted = formatDate(date);
  dateCountMap.set(formatted, (dateCountMap.get(formatted) || 0) + 1);
});

const contractMap = new Map();
response.ProcessAndNeeds.forEach(item => {
  const contract = item?.Contract;
  if (contract && contract.toLowerCase() !== 'no order') {
    contractMap.set(contract, (contractMap.get(contract) || 0) + 1);
  }
});

console.log('Contract counts map:', contractMap);
// Convert to array of { contract, count } and sort alphabetically

const uniqueFormattedContractsWithCount = Array.from(contractMap.entries())
  .map(([contract, count]) => ({ contract, count }))
  .sort((a, b) => a.contract.localeCompare(b.contract));
console.log('Unique, formatted Contracts with count:', uniqueFormattedContractsWithCount);
setFilteredContracts(uniqueFormattedContractsWithCount);


// Convert to array of { date, count } and sort by date ascending
const uniqueFormattedDatesWithCount = Array.from(dateCountMap.entries())
  .map(([date, count]) => ({ date, count }))
  .sort((a, b) => new Date(a.date) - new Date(b.date));

console.log('Unique, formatted MedStartDates with count:', uniqueFormattedDatesWithCount);
setMedStartDates(uniqueFormattedDatesWithCount);

       let uniqueFormattedDates = Array.from(
          new Set(medStartDates.map(date => formatDate(date)))
        );

        // Sort dates in ascending order
        uniqueFormattedDates = uniqueFormattedDates.sort(
          (a, b) => new Date(a) - new Date(b)
        );


        console.log('Unique, formatted MedStartDates:', uniqueFormattedDates);
        

        console.log('Fetched contracts:', data);
      
        setContracts(data); 
      } catch (error) {
        console.error('Error fetching contract orders:', error);
        navigate('/error-page');
      }
      setLoading(false);
    };
  
    fetchContracts();
  }, []);

  const handleOrderClick = async (cardValue) => {
  // Determine column name based on selectedName
  const columnName = selectedName === 'Contract' ? 'Contract' : 'MedStartDate';
  // const result = await loadOrder(
  //   pharmacyId,
  //   "PROCESS",
  //   columnName,
  //   cardValue,
  //   userId,
  //   ""
  // );

  // if (result.success && Array.isArray(result.filterData) && result.filterData.length > 0) {
    //localStorage.setItem('filteredTask', JSON.stringify(result.filterData));
    navigate('/process-prescription', {state: { Contract: columnName, Value: cardValue, flagForMakingTask: true }});
  // } else {
  //   toast.error(result.message || 'No orders found for this contract');
  // }
};
  
  
// search filter for contracts and MedStartDates
  const filteredContractsSearch =
  selectedName === 'Contract'
    ? filteredContracts.filter(c =>
        c.contract.toLowerCase() !== 'no order' &&
        c.contract.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : medStartDates.filter(item =>
        item.date.toLowerCase().includes(searchTerm.toLowerCase())
      );


      console.log('serach data for contracts: = >' , filteredContracts , medStartDates)


  // for formatting the date
  const formatDate = (date) => {
    if (!date) return '';
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(date).toLocaleDateString('en-US', options);
  }

  //const filterMedStartDate = (())
  
  return (
    <div style={{ position: 'relative' }}>
      <MenuBar />
      <div className="dashboard-container">

{/* // Add this at the top of your component
const [showSidebar, setShowSidebar] = useState(false);

// Place this just before your main dashboard container */}
{/* <> */}
  {/* Sidebar trigger button - left center */}
  {/* {!showSidebar && (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 3000,
      }}
    >
      <button
        style={{
          background: '#ec008c',
          color: '#fff',
          border: 'none',
          borderRadius: '16px',
          padding: '24px 18px',
          fontWeight: 'bold',
          fontSize: '18px',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(236,0,140,0.15)',
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
        }}
        onClick={() => setShowSidebar(true)}
      >
        Compliance Concerns
      </button>
    </div>
  )} */}

  {/* Sidebar - slides in from left */}
  {/* {showSidebar && (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '340px',
        background: '#fff',
        boxShadow: '2px 0 16px rgba(236,0,140,0.10)',
        zIndex: 4000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '40px 32px',
        transition: 'left 0.3s',
      }}
    >
      <button
        style={{
          alignSelf: 'flex-end',
          marginBottom: '24px',
          background: '#ec008c',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          padding: '6px 16px',
          fontWeight: 'bold',
          fontSize: '14px',
          cursor: 'pointer',
        }}
        onClick={() => setShowSidebar(false)}
      >
        Close
      </button>
      <div style={{ color: '#ec008c', fontWeight: 'bold', fontSize: '20px', marginBottom: '10px' }}>
        Primary Appeals Contact
      </div>
      <div>
        <strong>Name:</strong> Reveka Pinkhasova
      </div>
      <div>
        <strong>Title:</strong> Program Director, Clinical Services
      </div>
      <div>
        <strong>Email:</strong>{' '}
        <a href="mailto:rpinkhasova@win-healthcare.com" style={{ color: '#ec008c', textDecoration: 'underline' }}>
          rpinkhasova@win-healthcare.com
        </a>
      </div>
      <div>
        <strong>Mailing Address:</strong><br />
        1 American Lane<br />
        Greenwich, CT 06831
      </div>
      <div>
<a
  href="/documents/TN Addendum To WINRx PBM Manual V5 (1).docx"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: '#ec008c',
    textDecoration: 'underline',
    fontWeight: 'bold'
  }}
>
  View TN Addendum To WINRx PBM Manual
</a>
      </div>
    </div>
  )}
</> */}

        {/* <div  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '30px 0'
  }}>

    <span
    style={{
      
      color: 'black',
      borderRadius: '20px',
      padding: '10px 28px',
      fontSize: '20px',
      fontWeight: 'bold',
      fontFamily: 'Segoe UI',
      marginRight: '18px',
      letterSpacing: '1px'
    }}
  >
    Compliance Control
  </span>
  <ToggleButtonGroup
      value={selectedCompliance}
      exclusive
      onChange={(e, value) => {
        if (value !== null) {
          setSelectedCompliance(value);
        }
      }}
      className="dashboard-toggle-group"
      size="small"
      aria-label="Select filter type"
    >
      <ToggleButton value="on" aria-label="Contract" className="dashboard-toggle-btn">
        ON
      </ToggleButton>
      <ToggleButton value="off" aria-label="Meds Needed Date" className="dashboard-toggle-btn">
        OFF
      </ToggleButton>
    </ToggleButtonGroup>

  </div>
      {selectedCompliance === 'on' && (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '30px',
    }}
  >
    <div
      className="dashboard-card"
      style={{
        background: '#fff',
        borderRadius: '18px',
        boxShadow: '0 2px 8px rgba(236,0,140,0.15)',
        padding: '32px 40px',
        minWidth: '340px',
        maxWidth: '400px',
        color: '#222',
        fontFamily: 'Segoe UI',
        fontSize: '16px',
        fontWeight: 500,
        border: '2px solid #ec008c',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      <div style={{ color: '#ec008c', fontWeight: 'bold', fontSize: '20px', marginBottom: '10px' }}>
        Primary Appeals Contact
      </div>
      <div>
        <strong>Name:</strong> Reveka Pinkhasova
      </div>
      <div>
        <strong>Title:</strong> Program Director, Clinical Services
      </div>
      <div>
        <strong>Email:</strong>{' '}
        <a href="mailto:rpinkhasova@win-healthcare.com" style={{ color: '#ec008c', textDecoration: 'underline' }}>
          rpinkhasova@win-healthcare.com
        </a>
      </div>
      <div>
        <strong>Mailing Address:</strong><br />
        1 American Lane<br />
        Greenwich, CT 06831
      </div>
    </div>
  </div>
)} */}

  {selectedCompliance === 'off' && (
  <div>

        <div
  style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1200px',
    margin: '20px auto',
    padding: '0 20px',
    flexWrap: 'wrap',
    gap: '10px',
    position: 'relative'
  }}
>
  {/* Empty div to balance left side */}
  <div style={{ minWidth: '200px' }}>
    {/* add toggle button  */}
    <ToggleButtonGroup
      value={selectedName}
      exclusive
      onChange={(e, value) => {
        if (value !== null) {
          setSelectedName(value);
          setSearchPlaceholder(`Search ${value === 'MedStartDate' ? 'Dates' : 'Contracts'}...`);
        }
      }}
      className="dashboard-toggle-group"
      size="small"
      aria-label="Select filter type"
    >
      <ToggleButton value="Contract" aria-label="Contract" className="dashboard-toggle-btn">
        Contract
      </ToggleButton>
      <ToggleButton value="MedStartDate" aria-label="Meds Needed Date" className="dashboard-toggle-btn">
        Meds Needed Date
      </ToggleButton>
    </ToggleButtonGroup>
  </div>

  {/* TOTAL OPEN ORDERS - Center */}
  <div
    style={{
      textAlign: 'center',
      flex: 1
    }}
  >
    <span
  style={{
    backgroundColor: '#fff',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    padding: '8px 20px',
    fontSize: '18px',
    fontWeight: '600',
    fontFamily: 'Segoe UI',
    display: 'inline-block'
  }}
>
  Total open orders:{" "}
  <span style={{ color: '#ec008c', fontWeight: 'bold' }}>
    {selectedName === 'Contract'
      ? filteredContracts.reduce((sum, c) => sum + (c["count"] || 0), 0)
      : medStartDates.reduce((sum, c) => sum + (c["count"] || 0), 0)}
  </span>
</span>
  </div>

  {/* SEARCH BAR - Right */}
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '300px',
      marginLeft: 'auto',
      marginRight: '30px'
    }}
  >
    <input
      type="text"
      placeholder= {searchPlaceholder}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        padding: '8px 10px 8px 32px',
        width: '100%',
        borderRadius: '20px',
        border: '1px solid rgb(236, 151, 202)',
        fontSize: '14px',
        fontFamily: 'Segoe UI',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        outline: 'none',
        transition: 'all 0.3s ease'
      }}
      onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgb(236, 151, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
      }}
    />
    <Search
      style={{
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '18px',
        color: '#888'
      }}
    />
  </div>
</div>



        <div className="dashboard-grid">
  {selectedName === 'Contract'
    ? filteredContractsSearch.map((c, index) => (
        <div
          key={index}
          className="dashboard-card"
          onClick={() => handleOrderClick(c.contract)}
          style={{ cursor: 'pointer' }}
        >
          <div>
            <div className="contract-title">
              {c.contract}
            </div>
          </div>
          <div
            className={`order-count ${
              c.count === 0
                ? 'order-count-zero'
                : 'order-count-nonzero'
            }`}
          >
            {c.count}
          </div>
        </div>
      ))
    : filteredContractsSearch.map((item, index) => (
        <div
          key={index}
          className="dashboard-card"
          onClick={() => handleOrderClick(item.date)}
          style={{ cursor: 'pointer' }}
        >
          <div>
            <span className="contract-title">
              {item.date}
            </span>
            <span 
              className={`order-count ${
                item.count === 0
                  ? 'order-count-zero'
                  : 'order-count-nonzero'
              }`}
              style={{ marginLeft: '120px' }}
            >
              {item.count}
            </span>
          </div>
        </div>
      ))
  }
</div>
      </div> )}
      {loading && (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              border: '6px solid #f3f3f3',
              borderTop: '6px solid #EC088C',
              borderRadius: '50%',
              width: 48,
              height: 48,
              animation: 'spin 1s linear infinite'
            }} />
            <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Loading...Please wait</div>
            <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
          </div>
      )}
    </div>
    </div>
  );
};

export default ContractDashboard;
